"use client";
import {
  useMenubar
} from "../__chunks/P5CRXI7E.js";
import "../__chunks/E5PXVSMA.js";
import "../__chunks/WSQNIDGC.js";
import "../__chunks/TW35PKTK.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/UVQLZ7T5.js";
import "../__chunks/TCAGH6BH.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/HGZKAGPL.js";
import "../__chunks/SWN3JYXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-bar.tsx
import { useEffect } from "react";
var TagName = "div";
var useMenuBar = createHook(
  function useMenuBar2(props) {
    useEffect(() => {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "MenuBar is deprecated. Use Menubar instead.",
          "See https://ariakit.org/reference/menubar"
        );
      }
    }, []);
    return useMenubar(props);
  }
);
var MenuBar = forwardRef(function MenuBar2(props) {
  const htmlProps = useMenuBar(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuBar,
  useMenuBar
};
